export const BREEDING_CYCLE_STATES = [
  "eggs_pending",
  "hatched",
  "free_swim",
  "parent_feeding",
  "growout",
  "failed",
  "completed",
] as const;

export type BreedingCycleState = (typeof BREEDING_CYCLE_STATES)[number];

export const EGG_RESULTS = ["hatched", "partial_hatch", "eaten", "white"] as const;
export type EggResult = (typeof EGG_RESULTS)[number];

export const BREEDING_TRANSITIONS: Readonly<
  Record<BreedingCycleState, readonly BreedingCycleState[]>
> = {
  eggs_pending: ["hatched", "failed"],
  hatched: ["free_swim", "failed"],
  free_swim: ["parent_feeding", "growout", "failed"],
  parent_feeding: ["growout", "failed"],
  growout: ["completed"],
  failed: [],
  completed: [],
};

export function breedingTransitionAllowed(
  from: BreedingCycleState,
  to: BreedingCycleState,
): boolean {
  return BREEDING_TRANSITIONS[from].includes(to);
}

export function stateForEggResult(result: EggResult): "hatched" | "failed" {
  return result === "hatched" || result === "partial_hatch" ? "hatched" : "failed";
}

export function breedingSeparationActionAllowed(state: BreedingCycleState): boolean {
  return ["eggs_pending", "hatched", "free_swim", "parent_feeding"].includes(state);
}

export function reproductionActionAvailable(hasActivePairOccupancy: boolean): boolean {
  return hasActivePairOccupancy;
}
